import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.less';

// STYLES
import '../global.scss';
import 'animate.css';

// eslint-disable-next-line import/prefer-default-export
export function registerStyles(app) {
	app.use(Antd);
}
